import { ECountries, ELocales } from '@/_types';

type TOutput = {
  locale: string;
  country: string;
};

export const getUrlParams = (): TOutput => {
  const fallbackCountry = ECountries.RU;
  const fallbackLocale = ELocales.RU;

  if (typeof window === 'undefined') {
    return {
      locale: fallbackLocale,
      country: fallbackCountry,
    };
  }

  const [country, locale] = window.location.pathname
    .replace('/about-portal', '')
    .split('/')
    .slice(1);

  return {
    locale: locale || fallbackLocale,
    country: country || fallbackCountry,
  };
};
